import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { siteConfig } from '../../config/siteConfig';
import { ErrorIcon } from '../Icons';

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 2rem 2.5rem;
  color: var(--text);

  h2 {
    margin: 0;
    font-size: 1.1rem;
  }

  p {
    margin: 0;
    color: var(--text-muted);
    font-size: 0.9rem;
    line-height: 1.6;
  }

  a {
    color: var(--active-blue);
    font-size: 0.9rem;
  }
`;

export function LocalStorageWarningModal() {
  const intl = useIntl();

  return (
    <Container>
      <TitleRow>
        <ErrorIcon />
        <h2>{intl.formatMessage({ id: 'localStorageWarning.title' })}</h2>
      </TitleRow>
      <p>{intl.formatMessage({ id: 'localStorageWarning.body' })}</p>
      <a
        href={siteConfig.guideLinks.enableLocalStorage}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({ id: 'localStorageWarning.linkText' })}
      </a>
    </Container>
  );
}
